import './Footer.css';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ApiService, { initialAuthState } from '../Services/ApiServices';
import locations from './locations';
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

function Footer() {
  const navigate = useNavigate();
  const [currentMapIndex, setCurrentMapIndex] = useState(0);
  const [branches, setBranches] = useState([]);

  // const nextMap = () => {
  //   setCurrentMapIndex((prevIndex) =>
  //     prevIndex === locations.length - 1 ? 0 : prevIndex + 1
  //   );
  // };

  // const prevMap = () => {
  //   setCurrentMapIndex((prevIndex) =>
  //     prevIndex === 0 ? locations.length - 1 : prevIndex - 1
  //   );
  // };

  const nextMap = () => {
    setCurrentMapIndex((prevIndex) =>
      prevIndex === branches.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevMap = () => {
    setCurrentMapIndex((prevIndex) =>
      prevIndex === 0 ? branches.length - 1 : prevIndex - 1
    );
  };

  const goToMap = (index) => {
    setCurrentMapIndex(index);
  };

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const payload = {
          companyCode: "WAY4TRACK",
          unitCode: "WAY4",
        };

        const response = await ApiService.post(
          "/branch/getBranchDetails",
          payload
        );

        if (response?.status) {
          const cleanedBranches = response.data.map(branch => ({
            id: branch.id,
            branchName: branch.branchName,
            branchNumber: branch.branchNumber,
            branchAddress: branch.branchAddress,
            email: branch.email,
            latitude: branch.latitude,
            longitude: branch.longitude,

            addressLine1: branch.addressLine1,
            addressLine2: branch.addressLine2,
            city: branch.city,
            state: branch.state,
            pincode: branch.pincode,
          }));


          setBranches(cleanedBranches);
        }

      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    fetchBranches();
  }, []);

  const handleEmailClick = (email) => {
    // window.open(`mailto:${email}`, '_blank');
    // window.location.href=`mailto:${email}`;
    const subject = encodeURIComponent("Need More Information");
    const body = encodeURIComponent("Hello, I want to know more about your services.");

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    window.open(gmailUrl, "_blank");
  };

  const handlePhoneClick = (phone) => {
    const cleanPhone = phone.replace(/[^\d+]/g, '');
    window.open(`tel:${cleanPhone}`, '_blank');
  };

  const handleTerms = () => {
    navigate("/termsandconditions");
  }

  const headOffice = branches.length > 0 ? branches[0] : null;

  const supportPhoneNumber = 7032213434
  const supportEmail = "support@way4track.com"

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-content">
          {/* Left Section - Brand & Links */}
          {/* <div className="footer-left">
            <div className="footer-brand">
              <div className="footer-logo">
                <h1>WAY4TRACK</h1>
              </div>
            </div>

            <div className="footer-links">
              <div className="footer-footer-column">
                <h4>Company</h4>
                <a href="/about">About Us</a>
                <a href="/products">Our Products</a>
                <a href="/Careers">Careers</a>
                <a href="/blogs">Blogs</a>
              </div>

              <div className="footer-footer-column">
                <h4>Support</h4>
                <a href="/contact">Contact Us</a>
                <a href="https://wa.me/917032213434?text=Hello%20I%20want%20more%20information" target="_blank" rel="noopener noreferrer">WhatsApp</a>
               
              </div>
            </div>
          </div> */}

          <div className="footer-left">

            {/* Company Intro */}
            <div className="footer-company">
              <h2 className="footer-logo">WAY4TRACK</h2>
              <p className="footer-description">
                WAY4TRACK is a leading GPS tracking and fleet management platform
                helping businesses monitor vehicles, improve efficiency, and reduce costs
                with real-time tracking and smart analytics.
              </p>
            </div>

            {/* Links + Office */}
            <div className="footer-links">

              <div className="footer-footer-column">
                <h4>Explore Way4Track</h4>
                <a href="/">Home</a>
                <a href="/about">About Us</a>
                <a href="/products">Products</a>
                <a href="/blogs">Blogs</a>
                <a href="/contact">Contact Us</a>
                <a href="/Careers">Careers</a>
              </div>

              <div className="footer-footer-column">
                <h4>Customer Support</h4>
                <a
                  href="tel:7032213434"
                  className="office-link"
                >
                  <FaPhoneAlt />  +91 7032213434
                </a>

                {/* <a
                  href="tel:7032213434"
                  className="contact-tag email-tag"
                >
                  +91 7032213434
                </a> */}

                <p
                  className="office-link"
                >
                  <FiMail /> <a href="mailto:support@way4track.com">support@way4track.com</a>
                </p>
                <a href="/my-profile?tab=orders">Order Tracking</a>
                <a href="/my-profile">My Account</a>
                <a href="/faqs">FAQs</a>
              </div>

              <div className="footer-footer-column">
                {/* <span className="legal-links"> */}
                <h4>Privacy Policies</h4>
                <Link to="/termsandconditions">Terms & Conditions</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/cancellation-policy">Cancellation & Refund Policy</Link>
                <Link to="/shipping-policy">Shipping Policy</Link>
                <Link to="/replacement-policy">Replacement Policy</Link>
                <Link to="/warranty-policy">Warranty Policy</Link>
                <Link to="/disclaimer-policy">Disclaimer</Link>
                {/* </span> */}
              </div>

              {/* 🔥 Head Office Card */}
              <div className="footer-footer-column">
                <h4>Head Office</h4>

                {headOffice ? (
                  <>
                    <p className="office-location">
                      <FaLocationDot /> {" "}
                      {
                        [
                          headOffice.addressLine1,
                          headOffice.addressLine2,
                          headOffice.city,
                          headOffice.state,
                          headOffice?.pincode ? `- ${headOffice.pincode}` : null
                        ]
                          .filter(Boolean)
                          .join(", ")
                      }
                    </p>

                    <p
                      className="office-link"
                      onClick={() => handlePhoneClick(headOffice.branchNumber)}
                    >
                      <FaPhoneAlt /> {headOffice.branchNumber || "N/A"}
                    </p>

                    <p
                      className="office-link"
                      onClick={() => handleEmailClick(headOffice.email)}
                    >
                      <FiMail /> {headOffice.email || "N/A"}
                    </p>
                  </>
                ) : (
                  <p>Loading office details...</p>
                )}
              </div>

            </div>
          </div>

          {/* Right Section - Ultra Compact Maps Carousel */}
          <div className="footer-right">
            <div className="maps-carousel-ultra-compact">
              <div className="carousel-header">
                <h3 className="carousel-title">Our Presence Across India</h3>
              </div>

              <div className="ultra-compact-carousel">
                {branches.length > 0 && (
                  <>
                    <div className="location-selector">
                      <select
                        value={currentMapIndex}
                        onChange={(e) => goToMap(parseInt(e.target.value))}
                        className="location-dropdown"
                      >
                        {branches.map((location, index) => (
                          <option key={index} value={index}>
                            {location.branchName?.trim().toLowerCase() === "visakhapatnam"
                              ? `Head Office - ${location.branchName}`
                              : location.branchName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="ultra-compact-map-container">
                      <div className="ultra-compact-map-embed">
                        <iframe
                          // title={locations[currentMapIndex].title}
                          // src={locations[currentMapIndex].mapEmbed}
                          title={branches[currentMapIndex]?.branchName}
                          src={`https://www.google.com/maps?q=${branches[currentMapIndex]?.latitude},${branches[currentMapIndex]?.longitude}&output=embed`}
                          width="100%"
                          height="100%"
                          style={{ border: 0, borderRadius: '6px' }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>

                    <div className="ultra-compact-info">
                      <div className="contact-buttons">
                        <button
                          type="button"
                          className="contact-btn email-btn"
                          // onClick={() => handleEmailClick(locations[currentMapIndex].email)}
                          onClick={() =>
                            handleEmailClick(branches[currentMapIndex]?.email)
                          }
                        >
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                          </svg>
                          Email
                        </button>
                        <button
                          className="contact-btn phone-btn"
                          // onClick={() => handlePhoneClick(locations[currentMapIndex].phone1)}
                          onClick={() =>
                            handlePhoneClick(
                              branches[currentMapIndex]?.branchNumber?.trim() || "7032213434"
                            )
                          }
                        >
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                          </svg>
                          Call
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">

        <div className="social-links">
          <a href="https://www.facebook.com/profile.php?id=61571588066942" target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/way4track/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            title="Instagram"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 2h8.5C18.216 4 20 5.784 20 7.75v8.5c0 1.966-1.784 3.75-3.75 3.75h-8.5C5.784 20 4 18.216 4 16.25v-8.5C4 5.784 5.784 4 7.75 4zm8.75 1.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
            </svg>
          </a>
          {/* <a href="#" className="social-link" target="_blank" rel="noopener noreferrer" title="Twitter">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a> */}
          <a href="https://www.youtube.com/@WAY4TRACK360" target="_blank" rel="noopener noreferrer" className="social-link" title="YouTube">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/sharon-telematics-pvt-ltd" target="_blank" rel="noopener noreferrer" className="social-link" title="LinkedIn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        </div>
        {/* <div> */}
        <div className="w4t-legalcard">
          <p className="w4t-legalcard__row">
            <span className="w4t-legalcard__brandline">
              <img
                className="w4t-legalcard__logo"
                src="/images/sharontelematics-logo.png"
                alt="Sharon Telematics Logo"
              />
              <strong className="w4t-legalcard__company">
                SHARON TELEMATICS PRIVATE LIMITED
              </strong>
            </span>

            <span className="w4t-legalcard__copy">
              © 2018–2026 <strong className="w4t-legalcard__mark">WAY4TRACK</strong>. All
              rights reserved.
            </span>

            <span className="w4t-legalcard__sep" aria-hidden="true">
              |
            </span>

            <span className="w4t-legalcard__dev">
              Developed by{' '}
              <strong className="w4t-legalcard__devmark">WAY4TRACK</strong>
            </span>
          </p>
        </div>
        {/* <p className="footer-bottom">
            © 2026 WAY4TRACK. All rights reserved. | Developed by <strong>WAY4TRACK</strong>
            <span className="footer-links">
              <a onClick={handleTerms}>Terms of Use</a> •
              <a onClick={handleTerms}>Privacy Policy</a> •
              <a onClick={handleTerms}>Legal Policies</a>
            </span>
          </p> */}
        {/* </div> */}
      </div>


    </footer>
  );
}

export default Footer;
